if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');

        // OLD Code - backup - 23-01-2026
        // button.addEventListener('click', (event) => {
        //   event.stopPropagation();
        //   this.expandShowMore(event);
        //   const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
        //   if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
        //     nextElementToFocus.querySelector('input').focus();
        //   }
        // });

        // New updated code - 23-01-2026
        // Handle clicks on the button and all its children (including spans)
        // Use capture phase to intercept before parent containers can handle it
        button.addEventListener('click', (event) => {
          // Only handle clicks inside the button element
          if (event.target.closest("button") || event.target === button) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            this.expandShowMore(event);
            const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
            if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
              nextElementToFocus.querySelector('input').focus();
            }
          }
        },true);

      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        if (!parentDisplay) return;
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
